import React, { useState } from "react";
import "./SelfPublishingPage.css";
import HeadlineArea from "./HeadlineArea";
import ProcessStepSelector from "../Shared/ProcessStepSelector/ProcessStepSelector";
import AcornSelfPublishing from "././StepsComponents/Step1/AcornSelfPublishing";
import SelfPublishingProcess from "./StepsComponents/Step2/SelfPublishingProcess";
import PublishingConsultingProcess from "./StepsComponents/Step3/PublishingConsultingProcess";
import PublishingCosts from "./StepsComponents/Step4/PublishingCosts";
import ConsultantMatching from "./StepsComponents/Step5/ConsultantMatching";
import Footer from "../../Footer";
const SelfPublishingPage = () => {
  const stepsData = [
    {
      label: "에이콘 자비 출판",
      Component: AcornSelfPublishing,
    },
    {
      label: "출판 과정",
      Component: SelfPublishingProcess,
    },
    {
      label: "출판 컨설팅",
      Component: PublishingConsultingProcess,
    },
    {
      label: "출판/컨설팅 비용",
      Component: PublishingCosts,
    },
    {
      label: "컨설턴트",
      Component: ConsultantMatching,
    },
  ];

  return (
    <>
      <HeadlineArea />
      <ProcessStepSelector stepsData={stepsData} />
      <Footer />
    </>
  );
};
export default SelfPublishingPage;
